import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'
export default class extends Controller {
  static targets = ['item']
  connect() {
    useDispatch(this)
  }

  toggleTextFromSelect(event) {
    const eventSourceElement = event.target
    const selectedOption = eventSourceElement.value
    if (eventSourceElement.hasAttribute(selectedOption)) {
      this.itemTargets.forEach((item) => {
        item.value = eventSourceElement.getAttribute(selectedOption)
      })
    }
  }
}
